import React from 'react';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import MailSendLineIcon from 'remixicon-react/MailSendLineIcon';
import isNullOrEmpty from '../../../services/helpers/isNullOrEmpty';

interface Props {
    type: string;
    children?: string;
    theme: DefaultTheme;
}

const EInvoiceAddress: React.FC<Props> = ({ type, children, theme }: Props) => {
    return (
        <Container title={type}>
            <MailSendLineIcon size={theme.icon.size.small} />
            {!isNullOrEmpty(children) ? (
                <Value>{children}</Value>
            ) : (
                <NotAvailable>Not available</NotAvailable>
            )}
        </Container>
    );
};

export default withTheme(EInvoiceAddress) as React.ComponentType<Omit<Props, 'theme'>>;

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    overflow-wrap: anywhere;
    grid-gap: 0.8rem;
`;

const StyledText = styled.span`
    color: ${props => props.theme.colors.text.primary};
    font-size: ${props => props.theme.text.size.medium};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 23rem;
`;

const Value = styled(StyledText)``;

const NotAvailable = styled(StyledText)`
    color: ${props => props.theme.colors.text.subtleSecondary};
`;
